import styled from '@emotion/styled';
import * as RadixAlertDialog from '@radix-ui/react-alert-dialog';
import { subTitle2 } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

import { LARGE_TABLET } from '@/styles/themes';

export const Overlay = styled(RadixAlertDialog.Overlay)`
  position: fixed;
  inset: 0;
  background-color: #141617;
  opacity: 0.6;
  z-index: 1000;
`;

export const Content = styled(RadixAlertDialog.Content)`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 320px;
  padding: 20px;
  gap: 20px;
  border-radius: 16px;
  background-color: ${vars.neutral[0]};
  z-index: 1001;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  box-shadow: 0px 8px 24px 0px rgba(95, 102, 107, 0.12);

  ${LARGE_TABLET} {
    display: flex;
    width: 460px;
    max-width: 460px;
    padding: 32px;
    top: 86px;
    transform: translate(-50%, 0);
  }
`;

export const Title = styled(RadixAlertDialog.Title)`
  ${subTitle2};
  color: ${vars.neutral[100]};

  ${LARGE_TABLET} {
    ${subTitle2};
    color: ${vars.neutral[100]};
  }
`;
